import {
    createBrowserRouter,
    createRoutesFromElements,
    Navigate,
    Route,
} from "react-router-dom"
import { AppProviders } from "context/AppProviders"
import { ErrorPage } from "pages/ErrorPage.tsx"
import { Layout } from "layouts/Layout.tsx"
import { EntityPage } from "pages/EntityPage.tsx"
import { BoardPage } from "pages/BoardPage.tsx"
import { RfidPage } from "pages/RfidPage.tsx"
import { InvoicesPage } from "pages/InvoicesPage.tsx"
import { SessionsPage } from "pages/SessionsPage.tsx"
import { StationsPage } from "pages/StationsPage.tsx"
import { PaymentPage } from "pages/PaymentPage.tsx"
import { UserAccountPage } from "pages/ProfilePage.tsx"
import { DriversPage } from "pages/DriversPage.tsx"
import Middleware from "middleware.tsx"
import { VehiclePage } from "pages/VehiclePage.tsx"
import { ChargingRulesPage } from "pages/ChargingRulesPage.tsx"

const isToggled = (import.meta.env.VITE_FEATURE_TOGGLE ?? "true") === "true"

export const routes = (
    <Route
        path="/"
        element={
            <Middleware>
                <Layout />
            </Middleware>
        }
        errorElement={<ErrorPage />}
    >
        <Route index element={<Navigate replace to="/cards" />} />
        {isToggled && (
            <Route
                path={"board"}
                element={<BoardPage />}
                errorElement={<ErrorPage />}
            />
        )}
        <Route
            path={"cards"}
            element={<RfidPage />}
            errorElement={<ErrorPage />}
        />
        {isToggled && (
            <Route
                path={"invoices"}
                element={<InvoicesPage />}
                errorElement={<ErrorPage />}
            />
        )}
        <Route
            path={"sessions"}
            element={<SessionsPage />}
            errorElement={<ErrorPage />}
        />
        {isToggled && (
            <Route
                path={"locations"}
                element={<StationsPage />}
                errorElement={<ErrorPage />}
            />
        )}
        <Route path={"settings"}>
            <Route
                index
                element={<Navigate replace to="/settings/drivers" />}
            />
            <Route
                path={"drivers"}
                element={<DriversPage />}
                errorElement={<ErrorPage />}
            />
            <Route
                path={"vehicles"}
                element={<VehiclePage />}
                errorElement={<ErrorPage />}
            />
            <Route
                path={"charging-rules"}
                element={<ChargingRulesPage />}
                errorElement={<ErrorPage />}
            />
            {isToggled && (
                <Route
                    path={"entity"}
                    element={<EntityPage />}
                    errorElement={<ErrorPage />}
                />
            )}
            {isToggled && (
                <Route
                    path={"payment"}
                    element={<PaymentPage />}
                    errorElement={<ErrorPage />}
                />
            )}
        </Route>
        <Route
            path={"user"}
            element={<UserAccountPage />}
            errorElement={<ErrorPage />}
        />
        <Route path="*" element={"404 page"} />
    </Route>
)
export const router = createBrowserRouter(
    createRoutesFromElements(<Route element={<AppProviders />}>{routes}</Route>)
)
